import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[100px] w-full rounded-xl border border-[#E5E5E1] bg-white px-4 py-3 text-sm text-[#1A1A1B] shadow-sm placeholder:text-[#BCBCBC] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E85C33]/20 focus-visible:border-[#E85C33] disabled:cursor-not-allowed disabled:opacity-50 resize-none",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
